import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=6369a7e8&scoped=true&"
import script from "./BlockTitle.vue?vue&type=script&lang=js&"
export * from "./BlockTitle.vue?vue&type=script&lang=js&"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=6369a7e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369a7e8",
  null
  
)

export default component.exports